<template>
    <div>
        <v-card class="ma-4 py-3 px-5" style="background-color: #5D327C; color: #ffffff;" v-for="(group, index) in contacts" :key="index">
            <p class="pt-3 pb-0 px-2">{{ index }} Contacts</p>
            <v-layout v-if="show[index] == false" row wrap>
                <v-flex xs12 class="px-4 pb-4">
                    No '{{ index }}' contact information yet...
                </v-flex>
            </v-layout>
            <v-card v-else class="px-2 mb-5 pb-0" v-for="(contact, key) in contacts[index]" :key="key">
                <v-card-text class="px-0 pb-0 pt-3 ma-0">
                    <v-row class="pa-0 ma-0">
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-text-field label="Name" disabled v-model="contact.contactName"></v-text-field>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-text-field label="Phone" v-model="contact.contactNumber"></v-text-field>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-text-field label="Email" disabled v-model="contact.contactEmail"></v-text-field>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-text-field label="Job title" v-model="contact.contactJobTitle"></v-text-field>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">     
                            <v-select label="Contact type" :items="options" v-model="contact.contactType"></v-select>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 pt-3 my-0">
                            <v-btn elevation="0" @click="updateContact(index, key)" block class="mt-0 button-style" color="primary">Update</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-card>
        <v-card class="ma-4 py-3 px-5" style="background-color: #5D327C; color: #ffffff;">
            <p class="pt-3 pb-0 px-2">Branch Information</p>
            <v-layout v-if="showBranches == false" row wrap>
                <v-flex xs12 class="px-4 pb-4">
                    No 'Branch' information yet...
                </v-flex>
            </v-layout>
            <v-card v-else class="px-2 mb-5 pb-0" v-for="(branch, index) in branches" :key="index">
                <v-card-text class="px-0 pb-0 pt-3 ma-0">
                    <v-row class="pa-0 ma-0">
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-text-field label="Code" disabled v-model="branches[index].code"></v-text-field>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-text-field label="Location" disabled v-model="branches[index].location"></v-text-field>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-text-field label="Number" v-model="branches[index].officeNumber"></v-text-field>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-text-field label="Main Contact" v-model="branches[index].mainContact"></v-text-field>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-btn elevation="0" @click="updateBranch(index)" class="mt-0 button-style mt-3" block color="primary">Update</v-btn>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-btn elevation="0" @click="deleteBranch(index)" class="mt-0 button-style mt-3" block color="error">Delete</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-card>
        <v-card class="ma-4 pb-7 pt-4 px-5" style="background-color: #252525; color: #ffffff;" >
            <p class="pt-3 pb-0 px-2">Create Contact</p>
            <v-card class="pt-2">
                <v-card-text>
                    <v-row>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-text-field label="Name" v-model="newContact.contactName"></v-text-field>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-text-field label="Phone" v-model="newContact.contactNumber"></v-text-field>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-text-field label="Email" v-model="newContact.contactEmail"></v-text-field>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-text-field label="Job title" v-model="newContact.contactJobTitle"></v-text-field>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">  
                            <v-select label="Contact type" :items="options" v-model="newContact.contactType"></v-select>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-btn elevation="0" @click="createContact" class="mt-3 button-style" block color="success">Create</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <p class="pt-4 pb-0 px-2">Create Branch</p>
            <v-card class="pt-2">
                <v-card-text>
                    <v-row>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-text-field label="Code" v-model="newBranch.code"></v-text-field>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-text-field label="Location" v-model="newBranch.location"></v-text-field>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-text-field label="Number" v-model="newBranch.officeNumber"></v-text-field>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-text-field label="Main Contact" v-model="newBranch.mainContact"></v-text-field>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-btn elevation="0" @click="createBranch" class="mt-3 button-style" block color="success">Create</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-card>
    </div>
</template>
<script>
import moment from 'moment'
import { Chrome } from 'vue-color'
import { VueEditor } from 'vue2-editor'
    export default {
        name: 'ClientDetails',
        data(){
            return {
                id: this.$route.params.id,
                options: ['Primary', 'Other', 'Delete'],
                tiers: ['Enterprise', 'Branded', 'Essential'],
                clientData: {},
                contacts: {},
                newContact: {},
                newBranch: {},
                primarys: {},
                others: {},
                branches: {},
                show: {},
                showBranches: false
            }
        },
        methods: {
            convert(){
                let newOfficeObject = {
                    code: this.clientData.location,
                    location: this.clientData.location,
                    officeNumber: this.clientData.contactNumber,
                    mainContact: this.clientData.contactName
                }
                firebase.firestore().collection('clients').doc(this.id).collection('branch-information').doc(newOfficeObject.code).set(newOfficeObject)
                .catch(err => { console.log(err) })
                let newContactObject = {
                    contactEmail: this.clientData.contactEmail,
                    contactJobTitle: this.clientData.contactJobTitle,
                    contactName: this.clientData.contactName,
                    contactNumber: this.clientData.contactNumber,
                    contactType: 'Primary'
                }
                firebase.firestore().collection('clients').doc(this.id).collection('contact-information').doc(newContactObject.contactEmail).set(newContactObject)
                .catch(err => { console.log(err) })
            },
            getClient(){
                firebase.firestore().collection('clients').doc(this.id).onSnapshot(docSnapshot => {
                    this.clientData = docSnapshot.data()
                }, err => { console.log(`Encountered error: ${err}`) })
                firebase.firestore().collection('clients').doc(this.id).collection('contact-information').onSnapshot(snapshot => {
                    this.resetContacts()
                    snapshot.forEach(doc => {
                        let contact = doc.data()
                        let email = contact.contactEmail
                        if(contact.contactType == 'Primary'){
                            this.primarys[email] = contact
                            this.show['Primary'] = true
                            this.contacts['Primary'] = this.primarys
                        }else if(contact.contactType == 'Other'){
                            this.others[email] = contact
                            this.show['Other'] = true
                            this.contacts['Other'] = this.others
                        }
                    })
                }, err => { console.log(`Encountered error: ${err}`) })
                firebase.firestore().collection('clients').doc(this.id).collection('branch-information').onSnapshot(snapshot => {
                    this.resetBranches()
                    snapshot.forEach(doc => {
                        let branch = doc.data()
                        let code = branch.code
                        this.branches[code] = branch
                        this.showBranches = true
                    })
                }, err => { console.log(`Encountered error: ${err}`) })
            },
            resetContacts(){
                this.primarys = {}
                this.others = {}
                this.contacts = {
                    'Primary': {},
                    'Other': {}
                }
                this.show = {
                    'Primary': false,
                    'Other': false
                }
            },
            resetBranches(){
                this.branches = {}
                this.showBranches = false
            },
            resetNewContact(){
                this.newContact = {
                    contactName: '',
                    contactJobTitle: '',
                    contactNumber: '',
                    contactEmail: '',
                    contactType: 'Other'
                }
            },
            resetNewBranch(){
                this.newBranch = {
                    location: '',
                    officeNumber: '',
                    code: '',
                    mainContact: ''
                }
            },
            updateBranch(index){
                firebase.firestore().collection('clients').doc(this.id).collection('branch-information').doc(index).update(this.branches[index])
                .catch(err => { console.log(err) })
            },
            deleteBranch(index){
                firebase.firestore().collection('clients').doc(this.id).collection('branch-information').doc(index).delete()
                .catch(err => { console.log(err) })
            },
            updateContact(index, key){
                let group = this.contacts[index]
                let contact = group[key]
                if(contact.contactType == 'Delete'){
                    firebase.firestore().collection('clients').doc(this.id).collection('contact-information').doc(contact.contactEmail).delete()
                    .catch(err => { console.log(err) })
                }else{
                    firebase.firestore().collection('clients').doc(this.id).collection('contact-information').doc(contact.contactEmail).update(contact)
                    .catch(err => { console.log(err) })
                }
            },
            createContact(){
                firebase.firestore().collection('clients').doc(this.id).collection('contact-information').doc(this.newContact.contactEmail).set(this.newContact)
                .then(() => { this.resetNewContact() }).catch(err => { console.log(err) })
            },
            createBranch(){
                firebase.firestore().collection('clients').doc(this.id).collection('branch-information').doc(this.newBranch.code).set(this.newBranch)
                .then(() => { this.resetNewBranch() }).catch(err => { console.log(err) })
            }
        },
        mounted(){
            this.getClient()
            this.resetNewContact()
            this.resetNewBranch()
        }
    }
</script>
<style>
</style>